const styles = {
  editingButtonsGroup: { display: 'flex', flexDirection: 'row', gap: '1rem' },
  snackBarAnchorOrigin: { vertical: 'bottom', horizontal: 'center' },
};

export default styles;
